module.exports = __webpack_public_path__ + "img/coursecard.7fa9f208.png";